import { sdkRequest } from '@eventbrite/http';
import { deepKeysToCamel } from '@eventbrite/transformation-utils';
import { TicketClass, TicketClassesResponse } from './models';

export const fetchTicketClassesInformation = async (
    eventId: string,
): Promise<{ ticketClasses: TicketClass[] }> =>
    sdkRequest(`/api/v3/events/${eventId}/?expand=ticket_classes`).then(
        (response: { ticket_classes: TicketClassesResponse[] }) => ({
            ticketClasses: deepKeysToCamel(response.ticket_classes),
        }),
    );

export const calculateTotalMinMaxPrice = (
    ticketClasses: TicketClass[] = [],
) => {
    const ticketCosts = ticketClasses
        .filter((ticketClass) => ticketClass.category === 'admission')
        .map((ticketClass) => {
            const cost = ticketClass.cost?.value ?? 0;
            const tax = ticketClass.tax?.value ?? 0;
            const fee = ticketClass.fee?.value ?? 0;
            return cost + tax + fee;
        });
    if (ticketCosts.length === 0) {
        return {
            min: 0,
            max: 0,
        };
    }
    return {
        min: Math.min(...ticketCosts),
        max: Math.max(...ticketCosts),
    };
};

interface FormatPriceAsUSDOptions {
    locale?: string;
    currency?: string;
}

export const formatPrice =
    (options: FormatPriceAsUSDOptions = {}) =>
    (price: number) =>
        new Intl.NumberFormat(options.locale ?? 'en-US', {
            style: 'currency',
            currency: options.currency ?? 'USD',
        }).format(price / 100);
